module.exports = __webpack_public_path__ + "static/media/ally_pro_web_8.15a6441a.jpg";